// Shared types for the block-based Home v2 system. Each block is a small,
// self-contained React component identified by a stable BlockId so variants
// (Cozy / Focused / Classic / Custom) can compose them in any order.

export const BLOCK_IDS = [
  'hero',
  'ai-ask',
  'vital-signs',
  'fun-zone',
  'for-you',
  'on-your-mind',
  'news',
  'announcements',
  'whats-new',
  'pinned',
  'all-apps-link',
  'all-apps-grid',
] as const;

export type BlockId = (typeof BLOCK_IDS)[number];

export type BlockSize = 'S' | 'M' | 'L';

// Persisted in user.preferences.customLayout — order matters, hidden blocks
// are still kept so the user can toggle them back on without re-picking sort.
export interface CustomBlockConfig {
  id: BlockId;
  visible: boolean;
  size?: BlockSize;
}

export const isBlockId = (s: unknown): s is BlockId =>
  typeof s === 'string' && (BLOCK_IDS as readonly string[]).includes(s);

export type HomeVariant = 'cozy' | 'focused' | 'classic' | 'custom';

export const HOME_VARIANTS: HomeVariant[] = ['cozy', 'focused', 'classic', 'custom'];

export const isHomeVariant = (s: unknown): s is HomeVariant =>
  typeof s === 'string' && (HOME_VARIANTS as readonly string[]).includes(s);
